module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gly-box"
  }, [_c('div', {
    staticClass: "gly-box-container"
  }, [_c('div', {
    staticClass: "gly-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.guanliyuan')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gly-box-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gly-box-list-item"
    }, [_c('div', {
      staticClass: "gly-box-list-item-left"
    }, [_c('img', {
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gly-box-list-item-left-content"
    }, [_c('span', {
      staticClass: "gly-box-list-item-left-content-span"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "gly-box-list-item-left-content-span1"
    }, [_vm._v("ID：" + _vm._s(item.recodeCode))])])]), _vm._v(" "), _c('img', {
      staticClass: "gly-box-list-item-img",
      attrs: {
        "src": require("../../assets/image/x_22_1@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.delAdmin(item.userId)
        }
      }
    })])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1a6f5be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/guanliyuan/guanliyuan.vue
// module id = 1051
// module chunks = 1